
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ScheduleTimes/ScheduleTimes.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ScheduleTimes.html');
        
        var script = require('./ScheduleTimes.ts').default;
        module.exports = require('./ScheduleTimes.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    